import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Select from "react-select";
import moment from "moment";
import Skeleton from "react-loading-skeleton";
import { Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import "react-loading-skeleton/dist/skeleton.css";
import AdminSidebar from "../../layouts/AdminSidebar";
import { Trash, Plus } from "react-bootstrap-icons";
import { handleNumericInput } from "../../util/utils";
import { authCall } from "../../../services";
import ImageUploads from "../../util/ImageUploads";

function LeaderboardPage() {
  const today = moment().format("YYYY-MM-DD");
  const [loading, setLoading] = useState(false);
  const { current } = useSelector((state) => state.user);
  const [loadingSubs, setLoadingSubs] = useState("");
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [companies, setCompanaies] = useState([]);

  const getNextSunday = (offsetWeeks = 0) => {
    const today = moment();
    const nextSunday = today.clone().startOf("week").add(7 + offsetWeeks * 7, "days");
    return nextSunday.format("YYYY-MM-DD");
  }
  

  const initialField = {
    id: 1,
    weekDate: getNextSunday(),
    goldDealFirst: "",
    goldCompanyFirst: "All Companies",
    goldImageFirst: "",
    isGoldImageFirstUploaded: false,
    goldDealSecond: "",
    goldCompanySecond: "All Companies",
    goldImageSecond: "",
    isGoldImageSecondUploaded: false,
    goldDealThird: "",
    goldCompanyThird: "All Companies",
    goldImageThird: "",
    isGoldImageThirdUploaded: false,

    sivlerDealFirst: "",
    sivlerCompanyFirst: "All Companies",
    sivlerImageFirst: "",
    isSivlerImageFirstUploaded: false,
    sivlerDealSecond: "",
    sivlerCompanySecond: "All Companies",
    sivlerImageSecond: "",
    isSivlerImageSecondUploaded: false,
    sivlerDealThird: "",
    sivlerCompanyThird: "All Companies",
    sivlerImageThird: "",
    isSivlerImageThirdUploaded: false,

    bronzeDealFirst: "",
    bronzeCompanyFirst: "All Companies",
    bronzeImageFirst: "",
    isBronzeImageFirstUploaded: false,
    bronzeDealSecond: "",
    bronzeCompanySecond: "All Companies",
    bronzeImageSecond: "",
    isBronzeImageSecondUploaded: false,
    bronzeDealThird: "",
    bronzeCompanyThird: "All Companies",
    bronzeImageThird: "",
    isBronzeImageThirdUploaded: false,
    new: true,
  };

  const [dailyDeals, setDailyDeals] = useState([initialField]);

  const getDealDetails = async () => {
    setLoading(true);
    const resp = await authCall("getDailyDeals", {});
    const deals = [];
    if (resp?.type === "success") {
      resp?.payload.forEach(async (el, index) => {
        deals.push({
          id: index,
          dailyDealId: el.id,
          date: el.deal_date,
          company: el.company,
          activityId: el.activity_id,
          activity: el.activity,
          activityList: [],
          priceOne: el.prize_one,
          priceOneQuantity: el.prize_one_quantity,
          priceTwo: el.prize_two,
          priceTwoQuantity: el.prize_two_quantity,
          priceThree: el.prize_three,
          priceThreeQuantity: el.prize_three_quantity,
          priceOneRemainQuantity: el.prize_one_quantity_remain,
          priceTwoRemainQuantity: el.prize_two_quantity_remain,
          priceThreeRemainQuantity: el.prize_one_quantity_remain,
          voucherImage: el.voucher,
        });
      });
      // setDailyDeals(deals);
      setLoading(false);
    }
  };

  const getCompanies = async () => {
    const resp = await authCall("getSearchList", {
      type: "booking",
    });
    if (resp?.type === "success") {
      setCompanaies(resp?.payload?.details);
    }
  };

  const getCompanyActivities = async (companyName) => {
    const resp = await authCall("getCompanyActivities", {
      companyName: companyName,
    });

    if (resp?.type === "success") {
      return resp?.payload?.details?.map((e) => ({
        ...e,
        label: e.activity_name,
      }));
    } else {
      return [];
    }
  };

  useEffect(() => {
    getDealDetails();
    getCompanies();
  }, []);

  const addDeal = () => {
    const newFields = [];
    const weekDate = getNextSunday(dailyDeals.length - 1);
    newFields.push({ ...initialField, id: dailyDeals.length + 1, weekDate: weekDate });
    setDailyDeals([...dailyDeals, ...newFields]);
  };

  const handleChangePlan = (id, name, value) => {
    setDailyDeals(
      dailyDeals.map((field) =>
        field.id === id ? { ...field, [name]: value } : field
      )
    );
  };

  const handleChangeQuantity = (id, name, value) => {
    const inputValue = handleNumericInput(value);
    if (inputValue !== null && inputValue.length < 5) {
      setDailyDeals(
        dailyDeals.map((field) =>
          field.id === id ? { ...field, [name]: inputValue } : field
        )
      );
    }
  };

  const handleSubmit = async (item) => {
    toast.dismiss();
    setLoadingSubs(`loading${item.id}`);
    console.log('values', item);
    const values = {
      userId: current.id,
      dailyDealId: item?.dailyDealId || "",
      date: item.date,
      company: item.company,
      activityId: item.activityId,
      activity: item.activity,
      priceOne: item.priceOne,
      priceOneQuantity: item.priceOneQuantity,
      priceTwo: item.priceTwo,
      priceTwoQuantity: item.priceTwoQuantity,
      priceThree: item.priceThree,
      priceThreeQuantity: item.priceThreeQuantity,
      voucherImage: item.isItemPhotoUploaded ? item.voucherImage : "",
    };
    const resp = await authCall("dailyDeals", values);
    if (resp?.type === "success") {
      setLoadingSubs("");
      toast.success(resp?.message);
    } else {
      setLoadingSubs("");
      toast.error(resp?.message);
    }
  };

  const handleDelete = (el) => {
    toast.warning(
      <div>
        <p>Are you sure you want to delete?</p>
        <Button
          variant="success"
          className="btn-sm"
          onClick={() => deleteItem(el)}
          disabled={loadingDelete || false}
        >
          {loadingDelete ? "Loading..." : "Yes"}
        </Button>
        <Button
          variant="danger"
          className="btn-sm"
          style={{ marginLeft: "2px" }}
          onClick={closeToast}
        >
          No
        </Button>
      </div>,
      {
        position: "top-center",
        autoClose: false,
        closeOnClick: false,
        draggable: false,
        closeButton: false,
      }
    );
  };

  const deleteItem = async (el) => {
    if (el.dailyDealId) {
      const resp = await authCall("deleteDailyDeal", {
        dailyDealId: el.dailyDealId,
        isSoft: true,
      });
      setLoadingDelete(true);
      if (resp?.type === "success") {
        closeToast();
        toast.success(resp?.message);
        setLoadingDelete(false);
        getDealDetails();
      } else {
        toast.error(resp?.message);
        setLoadingDelete(false);
      }
    } else {
      setDailyDeals(dailyDeals.filter((e) => e.id !== el.id));
      closeToast();
    }
  };

  const closeToast = () => {
    toast.dismiss();
  };

  const handleChangeComapny = async (id, selected, name) => {
    console.log(id, selected, name);
    setDailyDeals(
      dailyDeals.map((field) =>
        field.id === id
          ? { ...field, [name]: selected }
          : field
      )
    );
  };

  const handleChangeActivity = (id, selected) => {
    setDailyDeals(
      dailyDeals.map((field) =>
        field.id === id
          ? { ...field, activityId: selected.id, activity: selected }
          : field
      )
    );
  };

  const getItemPhoto = (id) => (img) => {
    setDailyDeals(
      dailyDeals.map((field) =>
        field.id === id
          ? { ...field, voucherImage: img, isItemPhotoUploaded: true }
          : field
      )
    );
  };

  return (
    <>
      <div className="restaurant-details-page py-4">
        <div className="container custom-container">
          <div className="row">
            <div className="col-md-4 col-lg-3 mb-4">
              <AdminSidebar />
            </div>
            <div className="col-md-8 col-lg-9">
              <div className="common-info-card">
                <div className="heading-title">Leaderboard Offers</div>

                {/* daily deals */}
                <div className="details-wrapper">
                  <div className="row">
                    <div className="col-12">
                      <div className="info-cover pb-lg-2">
                        <div
                          className="main-heading2 mb-3 mt-3"
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          Leaderboard Offers:
                          {loading && (
                            <Skeleton count={1} height={31} width={120} />
                          )}
                          {!loading && (
                            <Button
                              className="btn btn-custom btn-custom-sm fs-16"
                              onClick={addDeal}
                            >
                              <Plus />
                              Add Offer
                            </Button>
                          )}
                        </div>
                        {loading && (
                          <div className="text-center mt-3">
                            Loading... Please wait
                          </div>
                        )}
                        {!loading &&
                          dailyDeals.map((field, index) => (
                            <div key={index}>
                              <div className="row gx-3 d-flex flex-wrap align-items-center mb-3">
                                <div className="col-4">
                                  <label
                                    htmlFor="RestaurantPhone"
                                    className="fs-md-16 mb-2 text-custom-primary"
                                    style={{ fontWeight: 700 }}
                                  >
                                    Week
                                  </label>
                                  <input
                                    required
                                    type="date"
                                    className="form-control"
                                    autoComplete="off"
                                    value={field.weekDate}
                                    name="weekDate"
                                    onChange={(e) =>
                                      handleChangePlan(
                                        field.id,
                                        e.target.name,
                                        e.target.value
                                      )
                                    }
                                  />
                                </div>
                              </div>
                              {/* GOLD */}
                              <div>
                                <div
                                  className="main-heading2 mb-3 mt-4"
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  GOLD
                                </div>
                                {/* PRIZE HEDADING */}
                                <div className="row align-items-center">
                                  <div className="col-4">
                                    <div
                                      // className="main-heading2"
                                      style={{ fontSize: 18, fontWeight: 600 }}
                                    >
                                      First Prize
                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div
                                      // className="main-heading2"
                                      style={{ fontSize: 18, fontWeight: 600 }}
                                    >
                                      Second Prize
                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div
                                      // className="main-heading2"
                                      style={{ fontSize: 18, fontWeight: 600 }}
                                    >
                                      Third Prize
                                    </div>
                                  </div>
                                </div>

                                {/* GOLD DEALS */}
                                <div className="row align-items-center mt-2">
                                  {/* FIRST DEALS */}
                                  <div className="col-4">
                                    <label
                                      htmlFor="RestaurantPhone"
                                      className="fs-md-16 mb-2 text-custom-primary"
                                      style={{ fontWeight: 700 }}
                                    >
                                      Deal
                                    </label>
                                    <input
                                      required
                                      type="text"
                                      className="form-control"
                                      autoComplete="off"
                                      value={field.goldDealFirst}
                                      name="goldDealFirst"
                                      onChange={(e) =>
                                        handleChangePlan(
                                          field.id,
                                          e.target.name,
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                  {/* SECOND DEALS */}
                                  <div className="col-4">
                                    <label
                                      htmlFor="RestaurantPhone"
                                      className="fs-md-16 mb-2 text-custom-primary"
                                      style={{ fontWeight: 700 }}
                                    >
                                      Deal
                                    </label>
                                    <input
                                      required
                                      type="text"
                                      className="form-control"
                                      autoComplete="off"
                                      value={field.goldDealSecond}
                                      name="goldDealSecond"
                                      onChange={(e) =>
                                        handleChangePlan(
                                          field.id,
                                          e.target.name,
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                  {/* THIRD DEALS */}
                                  <div className="col-4">
                                    <label
                                      htmlFor="RestaurantPhone"
                                      className="fs-md-16 mb-2 text-custom-primary"
                                      style={{ fontWeight: 700 }}
                                    >
                                      Deal
                                    </label>
                                    <input
                                      required
                                      type="text"
                                      className="form-control"
                                      autoComplete="off"
                                      value={field.goldDealThird}
                                      name="goldDealThird"
                                      onChange={(e) =>
                                        handleChangePlan(
                                          field.id,
                                          e.target.name,
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </div>

                                {/* GOLD COMPANY */}
                                <div className="row align-items-center mt-2">
                                  {/* FIRST COMPANY */}
                                  <div className="col-4">
                                    <label
                                      htmlFor="RestaurantPhone"
                                      className="fs-md-16 mb-1 text-custom-primary"
                                      style={{ fontWeight: 700 }}
                                    >
                                      Company
                                    </label>
                                    <Select
                                      className="text-body mt-1"
                                      placeholder="Select"
                                      value={{
                                        label: field?.goldCompanyFirst,
                                        name: field?.goldCompanyFirst,
                                      }}
                                      onChange={(e) =>
                                        handleChangeComapny(
                                          field.id,
                                          e?.company_name,
                                          'goldCompanyFirst'
                                        )
                                      }
                                      options={companies}
                                    />
                                  </div>
                                  {/* SECOND COMPANY */}
                                  <div className="col-4">
                                    <label
                                      htmlFor="RestaurantPhone"
                                      className="fs-md-16 mb-1 text-custom-primary"
                                      style={{ fontWeight: 700 }}
                                    >
                                      Company
                                    </label>
                                    <Select
                                      className="text-body mt-1"
                                      placeholder="Select"
                                      value={{
                                        label: field?.goldCompanySecond,
                                        name: field?.goldCompanySecond,
                                      }}
                                      onChange={(e) =>
                                        handleChangeComapny(
                                          field.id,
                                          e?.company_name,
                                          'goldCompanySecond'
                                        )
                                      }
                                      options={companies}
                                    />
                                  </div>
                                  {/* THIRD COMPANY */}
                                  <div className="col-4">
                                    <label
                                      htmlFor="RestaurantPhone"
                                      className="fs-md-16 mb-1 text-custom-primary"
                                      style={{ fontWeight: 700 }}
                                    >
                                      Company
                                    </label>
                                    <Select
                                      className="text-body mt-1"
                                      placeholder="Select"
                                      value={{
                                        label: field?.goldCompanyThird,
                                        name: field?.goldCompanyThird,
                                      }}
                                      onChange={(e) =>
                                        handleChangeComapny(
                                          field.id,
                                          e?.company_name,
                                          'goldCompanyThird'
                                        )
                                      }
                                      options={companies}
                                    />
                                  </div>
                                </div>

                                {/* GOLD IMAGE */}
                                <div className="row align-items-center mt-2">
                                  {/* FIRST IMAGE */}
                                  <div className="col-4">
                                    <label
                                      htmlFor="RestaurantPhone"
                                      className="fs-md-16 mb-2 text-custom-primary"
                                      style={{ fontWeight: 700 }}
                                    >
                                      Image
                                    </label>
                                    <ImageUploads
                                      getImage={getItemPhoto(field.id)}
                                      uploadedImage={field?.goldImageFirst}
                                      aspectRation={3 / 2}
                                    />
                                  </div>
                                  {/* SECOND IMAGE */}
                                  <div className="col-4">
                                    <label
                                      htmlFor="RestaurantPhone"
                                      className="fs-md-16 mb-2 text-custom-primary"
                                      style={{ fontWeight: 700 }}
                                    >
                                      Image
                                    </label>
                                    <ImageUploads
                                      getImage={getItemPhoto(field.id)}
                                      uploadedImage={field?.goldImageSecond}
                                      aspectRation={3 / 2}
                                    />
                                  </div>
                                  {/* THIRD IMAGE */}
                                  <div className="col-4">
                                    <label
                                      htmlFor="RestaurantPhone"
                                      className="fs-md-16 mb-2 text-custom-primary"
                                      style={{ fontWeight: 700 }}
                                    >
                                      Image
                                    </label>
                                    <ImageUploads
                                      getImage={getItemPhoto(field.id)}
                                      uploadedImage={field?.goldImageThird}
                                      aspectRation={3 / 2}
                                    />
                                  </div>
                                </div>
                              </div>

                              {/* SILVER */}
                              <div>
                                <div
                                  className="main-heading2 mb-3 mt-5"
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  SIVER
                                </div>
                                {/* PRIZE HEDADING */}
                                <div className="row align-items-center">
                                  <div className="col-4">
                                    <div
                                      // className="main-heading2"
                                      style={{ fontSize: 18, fontWeight: 600 }}
                                    >
                                      First Prize
                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div
                                      // className="main-heading2"
                                      style={{ fontSize: 18, fontWeight: 600 }}
                                    >
                                      Second Prize
                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div
                                      // className="main-heading2"
                                      style={{ fontSize: 18, fontWeight: 600 }}
                                    >
                                      Third Prize
                                    </div>
                                  </div>
                                </div>

                                {/* SIVER DEALS */}
                                <div className="row align-items-center mt-2">
                                  {/* FIRST DEALS */}
                                  <div className="col-4">
                                    <label
                                      htmlFor="RestaurantPhone"
                                      className="fs-md-16 mb-2 text-custom-primary"
                                      style={{ fontWeight: 700 }}
                                    >
                                      Deal
                                    </label>
                                    <input
                                      required
                                      type="text"
                                      className="form-control"
                                      autoComplete="off"
                                      value={field.sivlerDealFirst}
                                      name="sivlerDealFirst"
                                      onChange={(e) =>
                                        handleChangePlan(
                                          field.id,
                                          e.target.name,
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                  {/* SECOND DEALS */}
                                  <div className="col-4">
                                    <label
                                      htmlFor="RestaurantPhone"
                                      className="fs-md-16 mb-2 text-custom-primary"
                                      style={{ fontWeight: 700 }}
                                    >
                                      Deal
                                    </label>
                                    <input
                                      required
                                      type="text"
                                      className="form-control"
                                      autoComplete="off"
                                      value={field.sivlerDealSecond}
                                      name="sivlerDealSecond"
                                      onChange={(e) =>
                                        handleChangePlan(
                                          field.id,
                                          e.target.name,
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                  {/* THIRD DEALS */}
                                  <div className="col-4">
                                    <label
                                      htmlFor="RestaurantPhone"
                                      className="fs-md-16 mb-2 text-custom-primary"
                                      style={{ fontWeight: 700 }}
                                    >
                                      Deal
                                    </label>
                                    <input
                                      required
                                      type="text"
                                      className="form-control"
                                      autoComplete="off"
                                      value={field.sivlerDealThird}
                                      name="sivlerDealThird"
                                      onChange={(e) =>
                                        handleChangePlan(
                                          field.id,
                                          e.target.name,
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </div>

                                {/* SILVER COMPANY */}
                                <div className="row align-items-center mt-2">
                                  {/* FIRST COMPANY */}
                                  <div className="col-4">
                                    <label
                                      htmlFor="RestaurantPhone"
                                      className="fs-md-16 mb-1 text-custom-primary"
                                      style={{ fontWeight: 700 }}
                                    >
                                      Company
                                    </label>
                                    <Select
                                      className="text-body mt-1"
                                      placeholder="Select"
                                      value={{
                                        label: field?.sivlerCompanyFirst,
                                        name: field?.sivlerCompanyFirst,
                                      }}
                                      onChange={(e) =>
                                        handleChangeComapny(
                                          field.id,
                                          e?.company_name,
                                          'sivlerCompanyFirst'
                                        )
                                      }
                                      options={companies}
                                    />
                                  </div>
                                  {/* SECOND COMPANY */}
                                  <div className="col-4">
                                    <label
                                      htmlFor="RestaurantPhone"
                                      className="fs-md-16 mb-1 text-custom-primary"
                                      style={{ fontWeight: 700 }}
                                    >
                                      Company
                                    </label>
                                    <Select
                                      className="text-body mt-1"
                                      placeholder="Select"
                                      value={{
                                        label: field?.sivlerCompanySecond,
                                        name: field?.sivlerCompanySecond,
                                      }}
                                      onChange={(e) =>
                                        handleChangeComapny(
                                          field.id,
                                          e?.company_name,
                                          'sivlerCompanySecond'
                                        )
                                      }
                                      options={companies}
                                    />
                                  </div>
                                  {/* THIRD COMPANY */}
                                  <div className="col-4">
                                    <label
                                      htmlFor="RestaurantPhone"
                                      className="fs-md-16 mb-1 text-custom-primary"
                                      style={{ fontWeight: 700 }}
                                    >
                                      Company
                                    </label>
                                    <Select
                                      className="text-body mt-1"
                                      placeholder="Select"
                                      value={{
                                        label: field?.sivlerCompanyThird,
                                        name: field?.sivlerCompanyThird,
                                      }}
                                      onChange={(e) =>
                                        handleChangeComapny(
                                          field.id,
                                          e?.company_name,
                                          'sivlerCompanyThird'
                                        )
                                      }
                                      options={companies}
                                    />
                                  </div>
                                </div>

                                {/* THIRD PRIZE */}
                                <div className="row align-items-center mt-2">
                                  {/* FIRST IMAGE */}
                                  <div className="col-4">
                                    <label
                                      htmlFor="RestaurantPhone"
                                      className="fs-md-16 mb-2 text-custom-primary"
                                      style={{ fontWeight: 700 }}
                                    >
                                      Image
                                    </label>
                                    <ImageUploads
                                      getImage={getItemPhoto(field.id)}
                                      uploadedImage={field?.sivlerImageFirst}
                                      aspectRation={3 / 2}
                                    />
                                  </div>
                                  {/* SECOND IMAGE */}
                                  <div className="col-4">
                                    <label
                                      htmlFor="RestaurantPhone"
                                      className="fs-md-16 mb-2 text-custom-primary"
                                      style={{ fontWeight: 700 }}
                                    >
                                      Image
                                    </label>
                                    <ImageUploads
                                      getImage={getItemPhoto(field.id)}
                                      uploadedImage={field?.sivlerImageSecond}
                                      aspectRation={3 / 2}
                                    />
                                  </div>
                                  {/* THIRD IMAGE */}
                                  <div className="col-4">
                                    <label
                                      htmlFor="RestaurantPhone"
                                      className="fs-md-16 mb-2 text-custom-primary"
                                      style={{ fontWeight: 700 }}
                                    >
                                      Image
                                    </label>
                                    <ImageUploads
                                      getImage={getItemPhoto(field.id)}
                                      uploadedImage={field?.sivlerImageThird}
                                      aspectRation={3 / 2}
                                    />
                                  </div>
                                </div>
                              </div>

                              {/* BRONZE */}
                              <div>
                                <div
                                  className="main-heading2 mb-3 mt-5"
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  BRONZE
                                </div>
                                {/* PRIZE HEDADING */}
                                <div className="row align-items-center">
                                  <div className="col-4">
                                    <div
                                      // className="main-heading2"
                                      style={{ fontSize: 18, fontWeight: 600 }}
                                    >
                                      First Prize
                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div
                                      // className="main-heading2"
                                      style={{ fontSize: 18, fontWeight: 600 }}
                                    >
                                      Second Prize
                                    </div>
                                  </div>
                                  <div className="col-4">
                                    <div
                                      // className="main-heading2"
                                      style={{ fontSize: 18, fontWeight: 600 }}
                                    >
                                      Third Prize
                                    </div>
                                  </div>
                                </div>

                                {/* FIRST PRIZE */}
                                <div className="row align-items-center mt-2">
                                  {/* BRONZE DEALS */}
                                  <div className="col-4">
                                    <label
                                      htmlFor="RestaurantPhone"
                                      className="fs-md-16 mb-2 text-custom-primary"
                                      style={{ fontWeight: 700 }}
                                    >
                                      Deal
                                    </label>
                                    <input
                                      required
                                      type="text"
                                      className="form-control"
                                      autoComplete="off"
                                      value={field.bronzeDealFirst}
                                      name="bronzeDealFirst"
                                      onChange={(e) =>
                                        handleChangePlan(
                                          field.id,
                                          e.target.name,
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                  {/* SECOND DEALS */}
                                  <div className="col-4">
                                    <label
                                      htmlFor="RestaurantPhone"
                                      className="fs-md-16 mb-2 text-custom-primary"
                                      style={{ fontWeight: 700 }}
                                    >
                                      Deal
                                    </label>
                                    <input
                                      required
                                      type="text"
                                      className="form-control"
                                      autoComplete="off"
                                      value={field.bronzeDealSecond}
                                      name="bronzeDealSecond"
                                      onChange={(e) =>
                                        handleChangePlan(
                                          field.id,
                                          e.target.name,
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                  {/* THIRD DEALS */}
                                  <div className="col-4">
                                    <label
                                      htmlFor="RestaurantPhone"
                                      className="fs-md-16 mb-2 text-custom-primary"
                                      style={{ fontWeight: 700 }}
                                    >
                                      Deal
                                    </label>
                                    <input
                                      required
                                      type="text"
                                      className="form-control"
                                      autoComplete="off"
                                      value={field.bronzeDealThird}
                                      name="bronzeDealThird"
                                      onChange={(e) =>
                                        handleChangePlan(
                                          field.id,
                                          e.target.name,
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </div>

                                {/* BRONZE COMPNAY */}
                                <div className="row align-items-center mt-2">
                                  {/* FIRST COMPANY */}
                                  <div className="col-4">
                                    <label
                                      htmlFor="RestaurantPhone"
                                      className="fs-md-16 mb-1 text-custom-primary"
                                      style={{ fontWeight: 700 }}
                                    >
                                      Company
                                    </label>
                                    <Select
                                      className="text-body mt-1"
                                      placeholder="Select"
                                      value={{
                                        label: field?.bronzeCompanyFirst,
                                        name: field?.bronzeCompanyFirst,
                                      }}
                                      onChange={(e) =>
                                        handleChangeComapny(
                                          field.id,
                                          e?.company_name,
                                          'bronzeCompanyFirst'
                                        )
                                      }
                                      options={companies}
                                    />
                                  </div>
                                  {/* SECOND COMPANY */}
                                  <div className="col-4">
                                    <label
                                      htmlFor="RestaurantPhone"
                                      className="fs-md-16 mb-1 text-custom-primary"
                                      style={{ fontWeight: 700 }}
                                    >
                                      Company
                                    </label>
                                    <Select
                                      className="text-body mt-1"
                                      placeholder="Select"
                                      value={{
                                        label: field?.bronzeCompanySecond,
                                        name: field?.bronzeCompanySecond,
                                      }}
                                      onChange={(e) =>
                                        handleChangeComapny(
                                          field.id,
                                          e?.company_name,
                                          'bronzeCompanySecond'
                                        )
                                      }
                                      options={companies}
                                    />
                                  </div>
                                  {/* THIRD COMPANY */}
                                  <div className="col-4">
                                    <label
                                      htmlFor="RestaurantPhone"
                                      className="fs-md-16 mb-1 text-custom-primary"
                                      style={{ fontWeight: 700 }}
                                    >
                                      Company
                                    </label>
                                    <Select
                                      className="text-body mt-1"
                                      placeholder="Select"
                                      value={{
                                        label: field?.bronzeCompanyThird,
                                        name: field?.bronzeCompanyThird,
                                      }}
                                      onChange={(e) =>
                                        handleChangeComapny(
                                          field.id,
                                          e?.company_name,
                                          'bronzeCompanyThird'
                                        )
                                      }
                                      options={companies}
                                    />
                                  </div>
                                </div>

                                {/* BRONZE IMAGES */}
                                <div className="row align-items-center mt-2">
                                  {/* FIRST IMAGE */}
                                  <div className="col-4">
                                    <label
                                      htmlFor="RestaurantPhone"
                                      className="fs-md-16 mb-2 text-custom-primary"
                                      style={{ fontWeight: 700 }}
                                    >
                                      Image
                                    </label>
                                    <ImageUploads
                                      getImage={getItemPhoto(field.id)}
                                      uploadedImage={field?.bronzeImageFirst}
                                      aspectRation={3 / 2}
                                    />
                                  </div>
                                  {/* SECOND IMAGE */}
                                  <div className="col-4">
                                    <label
                                      htmlFor="RestaurantPhone"
                                      className="fs-md-16 mb-2 text-custom-primary"
                                      style={{ fontWeight: 700 }}
                                    >
                                      Image
                                    </label>
                                    <ImageUploads
                                      getImage={getItemPhoto(field.id)}
                                      uploadedImage={field?.bronzeImageSecond}
                                      aspectRation={3 / 2}
                                    />
                                  </div>
                                  {/* THIRD IMAGE */}
                                  <div className="col-4">
                                    <label
                                      htmlFor="RestaurantPhone"
                                      className="fs-md-16 mb-2 text-custom-primary"
                                      style={{ fontWeight: 700 }}
                                    >
                                      Image
                                    </label>
                                    <ImageUploads
                                      getImage={getItemPhoto(field.id)}
                                      uploadedImage={field?.bronzeImageThird}
                                      aspectRation={3 / 2}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="row gx-3 d-flex flex-wrap align-items-center mb-3 mt-5">
                                <div className="col-4"></div>
                                <div className="col-4">
                                  <div className="d-flex align-items-center">
                                    <button
                                      type="button"
                                      style={{
                                        height: 40,
                                        width: "50%",
                                        zIndex: 0,
                                      }}
                                      className="btn btn-custom btn-custom-sm fs-16"
                                      onClick={() => handleSubmit(field)}
                                      disabled={
                                        `loading${field?.id}` === loadingSubs ||
                                        false
                                      }
                                    >
                                      {`loading${field?.id}` === loadingSubs
                                        ? "Loading..."
                                        : field.new
                                        ? `SUBMIT`
                                        : "UPDATE"}
                                    </button>
                                    {dailyDeals.length > 1 && (
                                      <Trash
                                        onClick={() => handleDelete(field)}
                                        className="cursor-pointer"
                                        style={{
                                          marginLeft: 10,
                                          color: "red",
                                          width: 25,
                                          height: 25,
                                        }}
                                      />
                                    )}
                                  </div>
                                </div>
                              </div>
                              <hr />
                            </div>
                          ))}

                        {dailyDeals.length === 0 && (
                          <div className="text-center mt-3">
                            No deals available
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LeaderboardPage;
